<script>
	let people = [
		{name: 'Ahmad', beltColor: 'black', age: 39, id: 0},
		{name: 'Amjad', beltColor: 'blue', age: 38, id: 1},
		{name: 'Ashraf', beltColor: 'Blue', age: 32, id: 2},
	];

	const handleDeleteMe = (id) => {
		// console.log(person.id)
		people = people.filter((person) => person.id != id)
	};
	// export let name;
	// let firstName = "Ahmad";
	// let lastName = "Obay";
	// let beltColor = 'black';

	// reactive value
	// $: fullName = `${firstName} ${lastName}`

	// reactive statement
	// $: {
	// 	console.log(beltColor)
	// 	console.log(fullName)
	// }

	// const handleClick = () => {
	// 	beltColor = 'orange';	
	// };

	// const handleInput = (e) => {
	// 	beltColor = e.target.value;
	// };

	let num = 10;
</script>

	

<main>
	{#if num > 20}
		<p>Greater than 20</p>
	{:else if num > 5}
		<p>Greater than 5</p>
	{/if}

	<!-- <h1>Hello {name}!</h1> -->
	<!-- <p style="color: {beltColor}">{fullName} - {beltColor} belt</p> -->
	<!-- <p>Visit the <a href="https://svelte.dev/tutorial">Svelte tutorial</a> to learn how to build Svelte apps.</p> -->
	<!-- <button on:click={handleClick}>update belt color</button> -->
	<!-- <input type="text" name="userinput" on:input={handleInput} value={beltColor}> -->
	
	<!-- <input type="text" bind:value="{firstName}">
	<input type="text" bind:value="{lastName}">
	<input type="text" bind:value="{beltColor}"> -->

	
	{#each people as person (person.id)}
		<div>
			<h4>{person.name}</h4>
			<p>{person.beltColor}</p>
			<button on:click={() => {handleDeleteMe(person.id)}}>Delete</button>
		</div>
	{:else}
		<p>There are no people to show...</p>
	{/each}
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>